// Banda «Hay una versión nueva del cotizador — Recargar» (28-oct-2026; la regla en logica/version-app.ts). Arriba, con las
// franjas, y no se cierra: se va al recargar. Con cambios sin guardar (Ampliación) pregunta antes de recargar.
import { useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { Boton, Dialogo } from './ui.tsx';
import { hayPendientes, olvidarPendientes } from '../logica/pendientes.ts';

export function BandaVersionNueva({ recargar = () => window.location.reload(), sinGuardar = hayPendientes }: { recargar?: () => void; sinGuardar?: () => boolean }) {
  const [preguntando, setPreguntando] = useState(false);
  const recargarYa = () => {
    // ya dijo que sí: sin el «¿Salir del sitio?» del navegador encima
    olvidarPendientes();
    recargar();
  };
  return (
    <>
      <div className="franja franja--version" role="status">
        <strong>Hay una versión nueva del cotizador</strong>
        <Boton chico variante="principal" icono={<RefreshCw aria-hidden />} onClick={() => (sinGuardar() ? setPreguntando(true) : recargar())}>
          Recargar
        </Boton>
      </div>
      <Dialogo
        abierto={preguntando}
        alCerrar={() => setPreguntando(false)}
        titulo="Cambios sin guardar"
        pie={
          <>
            <Boton variante="fantasma" onClick={() => setPreguntando(false)}>
              Guardar primero
            </Boton>
            <Boton variante="peligro" onClick={recargarYa}>
              Recargar y perderlos
            </Boton>
          </>
        }
      >
        <p>Tienes cambios sin guardar en «Ampliación». Si recargas ahora, se pierden. Guárdalos primero y luego toca «Recargar».</p>
      </Dialogo>
    </>
  );
}
